<template>
  <div>
    <audio
      controls="controls"
      hidden
      src="../../../assets/err.mp3"
      ref="erraudio"
    ></audio>
    <audio
      controls="controls"
      hidden
      src="../../../assets/success.wav"
      ref="successaudio"
    ></audio>

    <div class="item-info">
      <ul class="item-ul" v-for="(item, index) in info1" :key="index">
        <li class="item-li">
          <div class="item-left">
            <span>发货编码</span><span>{{ item.sourceNo }}</span>
          </div>
          <div class="item-right">
            <span>品牌</span><span>{{ item.brand }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>SKU名称</span><span>{{ item.productNameCN }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>是否带电</span><span>{{ item.isElectricityText }}</span>
          </div>
          <div class="item-right">
            <span>是否退税</span><span>{{ item.isReturnTaxText }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left">
            <span>型号</span><span>{{ item.model }}</span>
          </div>
          <div class="item-right">
            <span style="white-space: nowrap; padding-right: 15px"
              >shipmentid</span
            ><span>{{ item.shipmentID }}</span>
          </div>
        </li>
        <li class="item-li">
          <div class="item-left" style="word-break: break-all">
            <span>FNSKU</span><span>{{ item.fnsku }}</span>
          </div>
          <div class="item-right">
            <span>{{ item.barMarkDoHandle }}</span>
          </div>
        </li>
      </ul>
    </div>

    <div class="conventionalBox-info" v-if="info2.length">
      <p class="p-title">常规箱信息</p>
      <div v-for="(item, index) in info2" :key="index">
        <van-row type="flex" justify="center" align="center">
          <!-- <van-col span="6">箱号</van-col> -->
          <van-col span="8">单箱数量</van-col>
          <van-col span="8">件数</van-col>
          <van-col span="8">总数量</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <!-- <van-col span="6" class="other-cell">{{item.startBoxNo}}-{{item.endBoxNo}}</van-col> -->
          <van-col span="8" class="other-cell">{{ item.singleBoxQty }}</van-col>
          <van-col span="8" class="other-cell">{{ item.boxCount }}</van-col>
          <van-col span="8" class="other-cell">{{ item.totalBoxQty }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">长宽高(cm)</van-col>
          <van-col span="6" class="other-cell"
            >{{ item.boxLength }}*{{ item.boxWidth }}*{{
              item.boxHeight
            }}</van-col
          >
          <van-col span="6">箱号</van-col>
          <van-col span="6" class="other-cell"
            >{{ item.startBoxNo }}-{{ item.endBoxNo }}</van-col
          >
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">重量(kg)</van-col>
          <van-col span="6" class="other-cell">{{ item.boxWeight }}</van-col>
          <van-col span="6" style="line-height: 30px"
            >体积(cm<sup>3</sup>)</van-col
          >
          <van-col span="6" class="other-cell">{{ item.volume }}</van-col>
        </van-row>
        <!-- <van-row type="flex" justify="center" align="center">
                    <van-col span="6">调入仓SKU</van-col>
                    <van-col span="18" class="other-cell txt-left">{{item.inStockSKUCode}}</van-col>
                </van-row> -->
      </div>
    </div>

    <div class="conventionalBox-info" v-if="info3.length">
      <p class="p-title">混箱信息</p>
      <div v-for="(item, index) in info3" :key="index">
        <van-row type="flex" justify="center" align="center">
          <!-- <van-col span="6">箱号</van-col> -->
          <van-col span="8">单箱数量</van-col>
          <van-col span="8">件数</van-col>
          <van-col span="8">总数量</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <!-- <van-col span="6" class="other-cell">{{item.startBoxNo}}</van-col> -->
          <van-col span="8" class="other-cell">{{ item.singleBoxQty }}</van-col>
          <van-col span="8" class="other-cell">{{ item.boxCount }}</van-col>
          <van-col span="8" class="other-cell">{{ item.totalBoxQty }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">长宽高(cm)</van-col>
          <van-col span="6" class="other-cell"
            >{{ item.boxLength }}*{{ item.boxWidth }}*{{
              item.boxHeight
            }}</van-col
          >
          <van-col span="6">箱号</van-col>
          <van-col span="6" class="other-cell">{{ item.startBoxNo }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">重量(kg)</van-col>
          <van-col span="6" class="other-cell">{{ item.boxWeight }}</van-col>
          <van-col span="6" style="line-height: 30px"
            >体积(cm<sup>3</sup>)</van-col
          >
          <van-col span="6" class="other-cell">{{ item.volume }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">混箱SKU</van-col>
          <van-col
            span="18"
            class="other-cell txt-left"
            :style="{
              'font-size': item.boxDetail.length > 1 ? '12px' : '15px',
              'white-space': 'nowrap',
            }"
          >
            <span v-for="(itemD, indexD) in item.boxDetail" :key="indexD"
              >{{ itemD.sku }}({{ itemD.qty }})</span
            >
          </van-col>
        </van-row>
        <!-- <van-row type="flex" justify="center" align="center">
                    <van-col span="6">调入仓SKU</van-col>
                    <van-col span="18" class="other-cell txt-left">{{item.inStockSKUCode}}</van-col>
                </van-row> -->
      </div>
    </div>

    <div class="conventionalBox-info" v-if="info4.length">
      <p class="p-title">尾箱信息</p>
      <div v-for="(item, index) in info4" :key="index">
        <van-row type="flex" justify="center" align="center">
          <!-- <van-col span="6">箱号</van-col> -->
          <van-col span="8">单箱数量</van-col>
          <van-col span="8">件数</van-col>
          <van-col span="8">总数量</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <!-- <van-col span="6" class="other-cell">{{item.startBoxNo}}</van-col> -->
          <van-col span="8" class="other-cell">{{ item.singleBoxQty }}</van-col>
          <van-col span="8" class="other-cell">{{ item.boxCount }}</van-col>
          <van-col span="8" class="other-cell">{{ item.totalBoxQty }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">长宽高(cm)</van-col>
          <van-col span="6" class="other-cell"
            >{{ item.boxLength }}*{{ item.boxWidth }}*{{
              item.boxHeight
            }}</van-col
          >
          <van-col span="6">箱号</van-col>
          <van-col span="6" class="other-cell">{{ item.startBoxNo }}</van-col>
        </van-row>
        <van-row type="flex" justify="center" align="center">
          <van-col span="6">重量(kg)</van-col>
          <van-col span="6" class="other-cell">{{ item.boxWeight }}</van-col>
          <van-col span="6" style="line-height: 30px"
            >体积(cm<sup>3</sup>)</van-col
          >
          <van-col span="6" class="other-cell">{{ item.volume }}</van-col>
        </van-row>
        <!-- <van-row type="flex" justify="center" align="center">
                    <van-col span="6">调入仓SKU</van-col>
                    <van-col span="18" class="other-cell txt-left">{{item.inStockSKUCode}}</van-col>
                </van-row> -->
      </div>
    </div>
    <div style="white-space: nowrap">
      <textarea
        style="width: 94%; margin: 2%"
        placeholder="备注"
        maxlength="200"
        v-model="remark"
      ></textarea>
    </div>
    <div
      class="submit-box"
      v-if="$route.query.tabType == '待复核' && info1.length"
    >
      <button class="submit-btn" @click="submit">确认无误</button>
      <button class="submit-btn" @click="toBale">重新打包</button>
    </div>
  </div>
</template>

<script>
import {
  Icon,
  Badge,
  Picker,
  Popup,
  Field,
  Toast,
  Empty,
  List,
  Loading,
  Checkbox,
  Tab,
  Tabs,
  SwipeCell,
  Col,
  Row,
  Button,
  Cell,
  Dialog,
} from "vant";
import {
  GetRecheckDetailForBale,
  AddCheckforArkAsync,
} from "@/api/mobile/recheck_api";
import { getIsMixingBox } from "@/api/mobile/bale_api.js";
import { mixins } from "../mobileMixins";
import { mapMutations } from "vuex";
export default {
  data() {
    return {
      list: {},
      info1: {},
      info2: {},
      info3: {},
      info4: {},
      remark: "",
    };
  },
  components: {
    [Icon.name]: Icon,
    [Badge.name]: Badge,
    [Picker.name]: Picker,
    [Popup.name]: Popup,
    [Toast.name]: Toast,
    [List.name]: List,
    [Empty.name]: Empty,
    [Loading.name]: Loading,
    [Checkbox.name]: Checkbox,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [SwipeCell.name]: SwipeCell,
    [Col.name]: Col,
    [Row.name]: Row,
    [Button.name]: Button,
    [Cell.name]: Cell,
    [Dialog.Component.name]: Dialog.Component,
    [Field.name]: Field,
  },
  mixins: [mixins],
  created() {
    this.init();
  },
  methods: {
    ...mapMutations({}),

    init() {
      this.getDetail();
    },

    getDetail() {
      const { shippingPlanDetailID, stockingTaskID } = this.$route.query;

      const data = {
        shippingPlanDetailID,
        stockingTaskID,
      };

      GetRecheckDetailForBale(data).then((res) => {
        Toast.clear();
        if (res.status === 200) {
          const { taskDetail, wholeCase, mixingTank, theTrunk } = res.response;
          this.info1 = taskDetail;
          this.info2 = wholeCase;
          this.info3 = mixingTank;
          this.info4 = theTrunk;
          if (taskDetail.length > 0) {
            this.remark = taskDetail[0].remark;
          }
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toGetIsMixingBox(id, stockingTaskID) {
      const data = {
        shippingPlanDetailIDS: id,
        stockingTaskID: stockingTaskID,
      };
      getIsMixingBox(data).then((res) => {
        if (res.status === 200 && res.success) {
          this.$router.push({
            path:
              res.response == 1
                ? "/mobile/baleSingleSku"
                : "/mobile/baleMoreSku",
            query: { shippingPlanDetailID: id, stockingTaskID },
          });
        } else {
          Toast.fail(res.msg);
        }
      });
    },

    toBale() {
      const { shippingPlanDetailID, stockingTaskID } = this.info1[0];
      this.toGetIsMixingBox(shippingPlanDetailID, stockingTaskID);
    },
    showsound(isSuccess) {
      if (isSuccess) {
        this.$refs.successaudio.currentTime = 0;
        this.$refs.successaudio.play();
      } else {
        this.$refs.erraudio.currentTime = 0;
        this.$refs.erraudio.play();
      }
    },
    submit() {
      const that = this;
      const { shippingPlanDetailID } = this.$route.query;
      const { stockingTaskID, actualQty, quantity, sourceNo, skuCode } =
        this.info1[0];

      const fn = function () {
        const data = {
          StockingTaskID: stockingTaskID,
          ShippingPlanDetailID: shippingPlanDetailID,
          Remark: that.remark,
        };

        Toast.loading({
          message: "复核中...",
          forbidClick: true,
          overlay: true,
          duration: 0,
        });

        AddCheckforArkAsync(data).then((res) => {
          if (res.status === 200) {
            //this.showsound(true);
            Toast.success("复核成功");

            setTimeout(function () {
              that.$router.go(-2);
            }, 1500);
          } else {
            this.showsound(false);
            Toast.fail(res.msg);
          }
        });
      };

      if (actualQty < quantity) {
        Dialog.confirm({
          title: "确认",
          confirmButtonText: "确认无误",
          cancelButtonText: "取消",
          message: `发货计划：${sourceNo}，sku：${skuCode}，实际打包数量小于调拨数量，请确认是否无误？`,
        })
          .then(() => {
            fn();
          })
          .catch(() => {});
      } else {
        fn();
      }
    },
  },
};
</script>

<style lang="less" scoped>
@import "../../../style/mobile_common.less";
.item-info {
  padding: 10px;
  font-size: 14px;
  background-color: #f2f2f2;
  .item-ul {
    padding-left: 18.5%;
    .item-li {
      display: flex;
      align-content: flex-start;
      word-break: break-all;
      margin-bottom: 4px;
      padding-bottom: 4px;
      & > div {
        flex: 1;
        line-height: 25px;
        max-width: 100%;
        display: flex;
        & > span {
          vertical-align: text-top;
          &:first-child {
            text-align: start;
            padding-right: 10px;
            display: inline-block;
          }
          &:last-child {
            color: #3d5064;
          }
        }
        & > p {
          line-height: 20px;
          vertical-align: middle;
          color: #3d5064;
          margin: 0;
        }
      }
    }
  }
}
@media (max-width: 450px) {
  .item-info {
    font-size: 12px;
    .item-ul {
      padding: 0 2%;
      .item-li {
        .item-right {
          margin-left: 3%;
        }
        & > div {
          line-height: 22px;
          & > span {
            &:first-child {
              padding-right: 6px;
            }
            &:last-child {
              flex: 1;
            }
          }
        }
      }
    }
  }
}
.conventionalBox-info {
  font-size: 14px;
  border-bottom: 1px solid #cccccc;
}
.sign-photo-save {
  padding: 0 10px;
}
.submit-btn {
  width: 100%;
  height: 40px;
  border-radius: 5px;
  background-color: #169bd5;
  color: #fff;
  font-size: 18px;
  border: 0;
}
.hidden {
  display: none;
}
.addInfo {
  position: absolute;
  right: 1%;
  color: #027db4;
}
.p-title {
  font-weight: 600;
  margin-bottom: 0;
  padding-left: 10px;
  font-size: 14px;
}
::v-deep .van-col {
  text-align: center;
  background-color: #f2f2f2;
  height: 40px;
  line-height: 40px;
  font-size: 15px;
  border-right: 1px solid #cccccc;
  border-top: 1px solid #cccccc;
  // border-bottom: 1px solid #cccccc;
  &:last-child {
    border-right: 0;
  }
}
.other-cell {
  background-color: #fff !important;
}
.txt-left {
  padding-left: 10px;
  text-align: left !important;
}
.submit-box {
  position: static;
  padding: 20px 0;
  .submit-btn {
    margin-bottom: 10px;
    &:last-child {
      background-color: #ccc;
    }
  }
}
</style>